import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingRoles: false,
  loadingRole: false,
  loadingRoleCreate: false,
  loadingRoleUpdate: false,
  loadingRoleDelete: false,

  errorLoadingRoles: null,
  errorLoadingRole: null,
  errorCreatingRole: null,
  errorUpdatingRole: null,
  errorDeletingRole: null,

  roles: [],
  role: null,

  serverStatus: null,
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setLoadingRoles(state) {
      state.loadingRoles = true;
      state.errorLoadingRoles = null;
    },
    setLoadingRole(state) {
      state.loadingRole = true;
      state.errorLoadingRole = null;
    },
    setLoadingRoleCreate(state) {
      state.loadingRoleCreate = true;
      state.errorCreatingRole = null;
    },
    setLoadingRoleUpdate(state) {
      state.loadingRoleUpdate = true;
      state.errorUpdatingRole = null;
    },
    setLoadingRoleDelete(state) {
      state.loadingRoleDelete = true;
      state.errorDeletingRole = null;
    },

    setErrorLoadingRoles(state, { payload }) {
      state.loadingRoles = false;
      state.errorLoadingRoles = payload;
    },
    setErrorLoadingRole(state, { payload }) {
      state.loadingRole = false;
      state.errorLoadingRole = payload;
    },
    setErrorCreatingRole(state, { payload }) {
      state.loadingRoleCreate = false;
      state.errorCreatingRole = payload;
    },
    setErrorUpdatingRole(state, { payload }) {
      state.loadingRoleUpdate = false;
      state.errorUpdatingRole = payload;
    },
    setErrorDeletingRole(state, { payload }) {
      state.loadingRoleDelete = false;
      state.errorDeletingRole = payload;
    },

    setRoles(state, { payload }) {
      state.loadingRoles = false;
      state.errorLoadingRoles = null;
      state.roles = payload;
    },

    setRole(state, { payload }) {
      state.loadingRole = false;
      state.errorLoadingRole = null;
      state.role = payload;
    },

    createRoleSuccess(state, { payload }) {
      state.roles = [payload, ...state.roles];
      state.loadingRoleCreate = false;
      state.errorCreatingRole = null;
    },

    updateRoleSuccess(state, { payload }) {
      state.roles = state.roles.map((u) => (u.id === payload.id ? payload : u));

      if (state.role && state.role.id === payload.id) {
        state.role = payload;
      }

      state.loadingRoleUpdate = false;
      state.errorUpdatingRole = null;
    },

    deleteRoleSuccess(state, { payload: idToDelete }) {
      state.roles = state.roles.filter((u) => u.id !== idToDelete);

      if (state.role && state.role.id === idToDelete) {
        state.role = null;
      }

      state.loadingRoleDelete = false;
      state.errorDeletingRole = null;
    },

    setServerResponseStatus(state, { payload }) {
      // payload example:
      // { operation: "create", status: 201 }
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingRoles,
  setLoadingRole,
  setLoadingRoleInfo,
  setLoadingRoleCreate,
  setLoadingRoleUpdate,
  setLoadingRoleDelete,

  setErrorLoadingRoles,
  setErrorLoadingRole,
  setErrorLoadingRoleInfo,
  setErrorCreatingRole,
  setErrorUpdatingRole,
  setErrorDeletingRole,

  setRoles,
  setRole,
  createRoleSuccess,
  updateRoleSuccess,
  deleteRoleSuccess,

  setServerResponseStatus,
} = roleSlice.actions;

export default roleSlice.reducer;

export const selectRole = (state) => state.role;
